import { connectMenu } from 'instantsearch.js/es/connectors';

// create the render function
const renderMenuSelect = (renderOptions) => {
    const { items, refine, widgetParams } = renderOptions;

    if (items.length === 0) return;

    widgetParams.container.innerHTML = `
        <select class="h-auto pl-0 pr-6 border-none bg-transparent bg-right [field-sizing:content]">
            <option value="">${widgetParams.title}</option>
            ${items.map((item) => `
                <option value="${item.value}"${item.isRefined ? ' selected' : ''}>${item.label === 'All Terrain' ? 'All-Terrain' : item.label}</option>
            `).join('')}
        </select>
    `;

    const select = widgetParams.container.querySelector('select');
    select.addEventListener('change', (event) => {
        event.preventDefault();
        refine(select.value);
    });
};

// create the custom widget
const customMenuSelect = connectMenu(renderMenuSelect);

export default customMenuSelect;
